<template>
    <el-dialog :visible.sync="visible" width="50%" :before-close="handleClose">
        <div class="flex titleBox" slot="title">
            <div class="flex">{{ data.shop_name }}-溢价比例修改记录</div>
        </div>
        <div>
            <el-table :data="data.spill_price_percent_logs" style="width: 100%" height="30vh">
                <el-table-column prop="shop.spill_price_percent" label="溢价比例">
                    <template slot-scope="scope"> {{ scope.row.spill_price_percent }} % </template>
                </el-table-column>
                <el-table-column prop="admin_name" label="操作人"></el-table-column>
                <el-table-column prop="time" label="修改时间"></el-table-column>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">返 回</el-button>
            <!-- <el-button type="primary" @click="downloadElsx">下载</el-button> -->
        </span>
    </el-dialog>
</template>

<script>
import { request } from '@/common/request';
import XLSX from 'xlsx';
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {
            list: []
        };
    },
    // watch: {
    //     visible: {
    //         handler(val) {
    //             if (val) {
    //                 this.getList();
    //             }
    //         },
    //         deep: true
    //     }
    // },
    methods: {
        getList() {
            request.get('/goods/option/premium?id=' + this.data.id, {}).then((res) => {
                if (res.code == 1) {
                    this.list = res.data.list;
                    // console.log(this.list, 'this.list');
                }
            });
        },
        handleClose() {
            this.$emit('update:visible', false);
            // this.$emit('synchronousClose', {});
        },
        downloadElsx() {
            if (!this.list.length) {
                this.$message.error('无可下载内容');
                return;
            }

            let list = [];
            for (let i of this.list) {
                list.push({
                    商品编码: this.data.goodssn,
                    sku编码: i.goods_option.productsn,
                    门店名称: i.shop.shop_name,
                    溢价比例: `${i.shop.spill_price_percent}%`,
                    原销售价: i.goods_option.productprice,
                    溢价后售价: i.premium_price
                });
            }

            // 创建工作簿
            const workbook = XLSX.utils.book_new();

            // 创建工作表
            const worksheet = XLSX.utils.json_to_sheet(list);

            // 将工作表添加到工作簿
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            // 将工作簿保存为Blob对象
            const blob = new Blob([XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            // 创建下载链接并触发下载操作
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = '门店溢价明细列表.xlsx'; // 设置下载文件的文件名
            document.body.appendChild(link);
            link.click(); // 触发下载操作
            document.body.removeChild(link);
        }
    }
};
</script>

<style lang="scss" scoped>
.flex {
    display: flex;
    align-items: center;
}
.titleBox {
    & > div:first-child {
        margin-right: 20px;
    }

    & > div:last-child {
        font-size: 14px;
        & > div:first-child {
            & > span {
                color: green;
            }
        }

        & > div:last-child {
            margin-left: 10px;
            & > span {
                color: red;
            }
        }
    }
}
</style>